import * as React from "react";
import * as ReactDOM from "react-dom";
import styled from "styled-components";
import { TextField, ITextField, Icon } from "office-ui-fabric-react";

export interface Props
{
    value: string;
    isEditing?: boolean;
    onChange?: (newValue: string) => void;
    onClick?: () => void;
    onDismiss?: () => void;
    multiline?: boolean;
}

const EditableLabelMultiLine = styled.span`
    cursor: pointer;
    width:100%;
    height: 100%;
    display: block;
    white-space: pre-wrap;
    clear: both;
    padding: 2%;
    width: 96% !important;
    background: white;
    i{
        color: gray;
        font-size: 0.8em;
    }
`;


const TextFieldEditorMultiLine = styled.div`
    position: relative;
    min-height: 3.4em;
    clear: both;
    textarea{
        padding: 1.9%;
        width: 96.2% !important;
        font-family: sans-serif;
        font-size: 16px;
       
        line-height: inherit;
    }
    i{
        position: absolute;
        right: 0px;
        bottom: 0px;
        cursor: pointer;
        &.save {
            right: 20px;
            font-size: 1.8em;
            bottom: -4px;
            color: green;
        }
        &.cancel{
            color: red;
        }
    }
`;
const EditableLabel = styled.span`
    cursor: pointer;
    width:100%;
    height: 100%;
    display: block;
    margin: 6px 0px 30px 0px;
    
    i{
        color: gray;
        font-size: 0.8em;
    }
`;
const TextFieldEditor = styled.div`
    position: relative;
    height: 3.4em;
    clear: both;
    input{
        padding: 0px;
        font-family: sans-serif;
        font-size: 16px;
    
        line-height: inherit;
    }
    i{
        position: absolute;
        right: 0px;
        bottom: -6px;
        cursor: pointer;
        &.save {
            right: 20px;
            font-size: 1.8em;
            bottom: -11px;
            color: green;
        }
        &.cancel{
            color: red;
        }
    }
`;

interface State
{
    value: string;
}
class CustomTextInput extends React.Component<Props, State>
{
    private field = React.createRef<ITextField>();
    state = {
        value: this.props.value
    };

    componentDidUpdate(prevProps: Props)
    {
        if (this.field.current)
        {
            if (prevProps.isEditing === false && this.props.isEditing === true)
            {
                this.field.current.focus();
            }
        }
    }

    private onEditClick = () => 
    {
        const { onClick } = this.props;
        if (onClick)
        {
            onClick();
        }
    }

    private onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) =>
    {
        const { value, selectionStart } = e.currentTarget;
        if (e.key === "Enter" )
        {
            if (e.ctrlKey)
            {
                if (selectionStart)
                {
                    
                    const firstPart = value.substr(0, selectionStart);
                    const lastPart = value.substr(selectionStart, value.length );

                    const element: HTMLInputElement =ReactDOM.findDOMNode(e.currentTarget) as HTMLInputElement;
                    this.setState({ value: firstPart + "\n" + lastPart }, () =>
                    {
                        //Update position to the new one
                        element.selectionEnd = selectionStart + 1;
                    });
                }
                else
                {
                    this.setState({ value: value + "\n" });
                }
            }
            else if (e.shiftKey)
            {
                this.setState({ value });
            }
            else
            {
                this.onSave();
            }
        }
        else if (e.key === "Escape")
        {
           this.onDismiss();
        }
        else
        {
            this.setState({ value });
        }
        
        
       
    }

    private onSave = () =>
    {
        const { onChange } = this.props;
        if (onChange)
        {
            onChange(this.state.value);
        }
    }

    private onDismiss = () =>
    {
        const { onDismiss } = this.props;
        if (onDismiss)
        {
            onDismiss();
        }
    }
   
    render()
    {
        
        const { value, isEditing = false, multiline } = this.props;
        const content = (
            <>
            <TextField
                    multiline={multiline || false} 
                    autoAdjustHeight={true} 
                    componentRef={this.field} 
                    onKeyUp={this.onKeyPress} 
                    value={this.state.value}
                />
                <Icon className="save" onClick={this.onSave} iconName="CheckMark" />
                <Icon className="cancel" onClick={this.onDismiss} iconName="ChromeClose" />
            </>
        );
        if (isEditing)
        {
            if (multiline)
            {
                return (
                    <TextFieldEditorMultiLine>
                        {content}
                    </TextFieldEditorMultiLine>
                );
            }
            return (
                <TextFieldEditor>
                    {content}
                </TextFieldEditor>
            );
            
        }
        else
        {
            const content = value && value.length > 0 ? value : <i>Click to edit</i>;
            if (multiline)
            {
                return (<EditableLabelMultiLine onClick={this.onEditClick}>{content}</EditableLabelMultiLine>);
            }
            return (<EditableLabel onClick={this.onEditClick}>{content}</EditableLabel>);
        }
    }
}
 export default CustomTextInput;


// WEBPACK FOOTER //
// ./src/components/baseComponent/CustomTextInput.tsx